// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  baseUrl: 'https://grant.testcenter.kz/api/v1'
  // baseUrl: 'http://192.168.200.15:28080/certificate/api/v1'
  // baseUrl: 'http://93.190.243.120:28080/certificate/api/v1'
};



// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/environments/environment.ts